
  <div [ngSwitch]="layout">
    <div *ngSwitchCase="'default'">
      <shop-view-new *ngIf="modelService.catalogService.product" [(model)]="modelService.catalogService.product"></shop-view-new>
    </div>
    <div *ngSwitchCase="'lukas'">
      <!--<shopViewLukas></shopViewLukas>-->
    </div>
  </div>
  {{errorMessage}}
